import { Component, Input } from '@angular/core';

import { TranslationKeyMap } from '../form.i18n';

@Component({
    selector: 'cmps-eval-score-label',
    templateUrl: './score-label.component.html',
    host: {
        class: 'cmps-eval-score-label',
    },
})
export class ScoreLabelComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    @Input() hideLabel: boolean;
    @Input() numerator: number;
    @Input() denominator: number;
    @Input() percentage: number;
}
